<template>
  <div class="stuHome">
    <div class="pubBg">
      <div class="stuHeader">
        <img :src="logoSrc" alt="" id="logo" class="logoImg">
        <div class="nav" v-if="hidNavList.indexOf(pageName) === -1">
          <span :class="{activeNav:pageName === item.name}" v-for="(item,index) in navList" :key="index" @click="handleNav(item.name)">{{item.title}}</span>
        </div>
        <div class="user" v-if="isShowUser">
          <el-dropdown>
            <span class="el-dropdown-link">
              {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goUserConfig">账号设置</el-dropdown-item>
              <el-dropdown-item @click.native="outLogin">安全退出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        </div>
      </div>
      <div class="stuMain">
        <router-view @home-flag="homeFlag" @home-planInfo="homePlanInfo" :userInfo="userInfo" :schoolInfo="schoolInfo"></router-view>
        <copyright class="copyright" />
      </div>
    </div>
  </div>
</template>

<script>
import { selectByOne } from "@/http/modules/custom";
import logoSet from '@/http/logoSet.js';
import { logoDefault } from '@/http/logoSet.js';
import copyright from '../../components/copyright.vue';
export default {
  components: { copyright },
  name: 'stuHome',
  data() {
    return {
      logoSrc: "",
      userName: "",
      pageName: "",
      isShowUser: false,
      hidNavList:['register','resetPassword','payTransfer','updatePassword'],
      planInfo : {},
      info : {},
      userInfo: {},
      schoolInfo: [],
      navList:[
        {
          title : '首页',
          name : 'home',
        },
        {
          title:"报名",
          name:"stuApply",
        },
        {
          title:"缴费",
          name:"payFee",
        },
        {
          title: "准考证",
          name: "ticket",
        },
        {
          title: "考试",
          name: "stuExam"
        },
        {
          title: "成绩",
          name: "stuScore"
        },
        {
          title: "公告",
          name: "stuNotice"
        }
      ],
      needPayment: '',
      currentTime: '',
    }
  },
  computed : {
    /*****************************
     * @isSignUp 能报名--true
     *****************************/
    isSignUp() {
      let { beginSign, endSign, isUseLastPlan, isPlanRegion } = this.planInfo;
      // 时间格式转换, 兼容 ios
      beginSign = beginSign.replace(/\-/g, '/');
      endSign = endSign.replace(/\-/g, '/');
      let { flag } = this.info;
      let currentTime = this.currentTime;
      beginSign = new Date(beginSign).getTime();
      endSign = new Date(endSign).getTime();
      if ((currentTime >= beginSign && currentTime <= endSign) && (flag === 0 || flag === null ||  flag === 3 || flag === 1) && !isUseLastPlan && isPlanRegion == '1') {
        return true
      } else {
        return false
      }
    },

    /*****************************
    * @isGoPay 能否去缴费
    *****************************/
    isGoPay(){
      let { flag } = this.info;
      let { startPay, endPay } = this.planInfo;
      startPay = startPay? startPay.replace(/\-/g, '/') : '';
      endPay = endPay? endPay.replace(/\-/g, '/') : '';
      let currentTime = this.currentTime;
      let startPayTime = new Date(startPay).getTime();
      let endPayTime = new Date(endPay).getTime();
      // 缴费时间范围内, 才可以去缴费
      if ( ( flag === 2 || flag === 5 ) && (currentTime < endPayTime && currentTime > startPayTime) ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods:{
    /***********************************
     * @getCurrentPlan 查询当前批次
     ***********************************/
    getCurrentPlan(){
      this.$api.applyManage.getCurrentPlan().then(res => {
        if (res.code == 1) {
          // 当前批次未设置 "下载准考证", 不显示准考证 nav
          if (res.data.downloadEntrance != 1) {
            this.navList.map( (item, index) => {
              if (item.name == 'ticket') {
                this.navList.splice(index,1);
              }
            })
          } else if (window.localStorage.getItem('tenant') == 'whkjdxcjsljbk'){
            this.navList.map((item,index)=>{
              if (item.name == 'ticket') {
                this.navList[index].title = '学生证明'
              }
            })
          }
        }
      })
    },

    /***********************************
     * @getSelectByOne 查询当前用户个人信息
     ***********************************/
    getSelectByOne(){
      selectByOne().then(res => {
        this.userInfo = res.data
        this.userName = res.data.realName
        this.schoolInfo = [];
        this.userInfo.extData.map( e => {
          if ( e.title == 2 && e.type != 'textarea' && e.type != 'imageUpload') {
            this.schoolInfo.push(e);
          }
        })
      })
    },

    /*************************
     * @homeFlag 接收home传的falg
     *************************/
    homeFlag(flag){
      if (this.$route.name != 'register' && this.$route.name != 'resetPassword') {
        this.info.flag = flag;
      }
    },
    
    /*************************
     * @homeFlag 接收home传的planInfo
     *************************/
    homePlanInfo(data){
      if (this.$route.name != 'register' && this.$route.name != 'resetPassword') {
        this.planInfo = data;
      }
      if (data.isPay != 1) {
        this.navList.map( (item, index) => {
          if (item.name == 'payFee') {
            this.navList.splice(index, 1);
          }
        })
      }
    },

    /*****************************
     * @getLogo 获取 Logo 链接
     *****************************/
    getLogo () {
      let tenant = window.localStorage.getItem('tenant')
      if (!tenant) {
        tenant = this.$route.query.tenant
      }
      logoSet('stu', tenant).then(({ code, data }) => {
          if (code == 1) {
            this.logoSrc = data
          } else {
            this.logoSrc = logoDefault('stu')
          }
      }).catch(() => {
          this.logoSrc = logoDefault('stu')
      })
    },

    /******************************
     * @handleNav 判断是否可以跳转到报名页
     ******************************/
    handleNav(name) {
      if (name === 'stuApply' && !this.isSignUp) {
        this.$message.warning('当前不能报名~')
        return
      } else if (name === "payFee" && !this.isGoPay) {
        this.$message.warning('当前无法缴费~');
        return;
      }
      this.$router.push({name:name})
    },

    /*******************************
     * @getPageName 获取路由名
     *******************************/
    getPageName() {
      this.pageName = this.$route.name
    },

    /*******************************
     * @goUserConfig 账号设置
     *******************************/
    goUserConfig () {
      this.$router.push({
        name: 'userConfig'
      })
    },

    /* ** getCurrentTime(获取当前时间) ** */
    getCurrentTime(){
      this.mixin_getServerTime().then( ({data})=>{
        this.currentTime = new Date(data ? data.replace(/\-/g, '/') : '').getTime();
      })
    },

    /*******************************
     * @outLogin 退出登录
     *******************************/
    outLogin() {
      this.mixin_outLogin()
    },

  },
  created () {
    if (this.$route.name != 'register' && this.$route.name != 'resetPassword') {
      this.isShowUser = true
      this.getCurrentPlan();
      this.getSelectByOne();
      this.getCurrentTime()
    }
  },
  mounted() {
    this.getPageName()
    this.getLogo()
  },
  watch: {
      $route:'getPageName'
  }
}
</script>
<style lang="less" scoped>
  .logoImg {
    max-width: 100%;
    max-height: 42px;
  }
  .stuHome {
    height: 100%;
    min-width: 1240px;
    background: #F4F5F8;
    position: relative;
    .pubBg {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      background: url('../../assets/stuImg/pubBg.jpg') no-repeat top center;
      background-size: 100% 360px;
      display: flex;
      flex-direction: column;
      .stuHeader{
        display: flex;
        padding: 10px 30px 0 30px;
        justify-content: space-between;
      }
      .nav {
        display: inline-block;
        vertical-align: top;
        color: #fff;
        flex: 1;
        margin-left: 50px;
        span {
          display: inline-block;
          vertical-align: top;
          height: 40px;
          line-height: 40px;
          margin-right: 60px;
          color: rgba(255, 255, 255, 0.75);
          font-size: 16px;
          cursor:pointer
        }
        .activeNav {
          color: #FFF!important;
          font-weight: 600!important;
        }
      }
      .user{
        height: 40px;
        line-height: 40px;
        color: #fff;
      }
    }
    .stuMain {
      width: 1240px;
      margin: 0 auto;
      margin-top: 78px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 18px;
      .footer{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 68px;
        background: #FFFFFF;
        box-shadow: 0px -8px 16px 0px rgba(0, 0, 0, 0.06);
        border-radius: 0px 0px 8px 8px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  /deep/ .el-dropdown {
    color: #fff;
  }
  /* 针对 IE 的版权样式(IE 8~ ) */
  .copyright {
    text-align: center\0;
    margin-top:280px\0;
    padding-bottom: 18px\0;
  }
  /* 针对 IE 样式 , 用 white 不用 #fff */
  /deep/ .stu-foot{
    background-color: white\0;
  }
</style>
